import React, { Fragment } from "react";
import { connect } from "react-redux";

import { AppState } from "shared/data/reducers";
import { OTransportCompanies } from "shared/gol-api/types/flightSearch";
import { FlightOptions } from "shared/lib/golObjectTypes/SearchFlightResponse/Response";
import { useToggle } from "shared/lib/hooks";

import FlightDetailStream from "@components/Flights/FlightDetailStream";
import FlightSegment from "@components/Flights/FlightSegment";
import FlightStreamHeader from "@components/Flights/FlightStreamHeader";
import AirportTitle from "@components/Formatters/AirportTitle";
import FormattedMessage from "@components/UI/FormattedMessage";

function ResultFlightInfo({
  flightOption,
  oTransportCompanies,
  index,
  isMulticity,
}: {
  flightOption: FlightOptions;
  oTransportCompanies: OTransportCompanies;
  index: number;
  isMulticity: boolean;
}) {
  const [showDetails, toggleShowDetailStream] = useToggle(false);
  if (Object.keys(oTransportCompanies).length === 0) return null;

  const isMultipleParts = Array.isArray(flightOption);

  const dateDeparture = isMultipleParts
    ? flightOption[0].DepartureDateTime
    : flightOption.DepartureDateTime;
  const oneFlightOption = isMultipleParts ? flightOption[0] : flightOption;

  const firstSegment = oneFlightOption.FlightSegments.FlightSegment[0];
  const technicalStops = oneFlightOption.FlightSegments.FlightSegment.filter(
    (flightSegment) => flightSegment.TechnicalStops !== undefined
  ).map(
    (flightSegment) => flightSegment.TechnicalStops.TechnicalStop[0].Destination
  );

  return (
    <div className={`flight-stream flight-stream-${index}`}>
      <FlightStreamHeader
        dateDeparture={dateDeparture}
        showDetails={showDetails}
        toggleShowDetailStream={toggleShowDetailStream}
        firstSegment={firstSegment}
        isMulticity={isMulticity}
        index={index}
      />
      <FlightSegment
        flightStream={flightOption}
        index={index}
        oTransportCompanies={oTransportCompanies}
        toggleShowDetailStream={toggleShowDetailStream}
      />
      <div className="result-flight-info-details">
        <FlightDetailStream
          selectedFlightStream={flightOption[0]}
          show={showDetails}
        />
      </div>
      {technicalStops.length > 0 && (
        <div className="result-flight-info-details-technical-stops">
          <FormattedMessage id="ResultFlightInfo.technicalStopAttention" />:{" "}
          {technicalStops.map((technicalStop, indexTechnicalStop) => (
            <Fragment key={indexTechnicalStop}>
              <AirportTitle airportCode={technicalStop} />
              {indexTechnicalStop < technicalStops.length - 1 ? ", " : ""}
            </Fragment>
          ))}
          . <FormattedMessage id="ResultFlightInfo.technicalStopVisa" />
        </div>
      )}
    </div>
  );
}

export default connect((state: AppState) => ({
  oTransportCompanies: state.search.oTransportCompanies,
}))(ResultFlightInfo);
